/**
 * Menu domain types: categories, products, ingredient substitutes, and tech cards (recipes).
 *
 * Monetary amounts are in Armenian dram (AMD) as numbers with up to 2 decimals.
 * Quantities allow up to 3 decimals per the HDM spec (e.g. 0.101 kg).
 */
/** Department tax type as defined by the HDM spec (op 1, dep.type). */
export var TaxType;
(function (TaxType) {
    /** ԱԱՀ-ով հարկվող — VAT taxable */
    TaxType[TaxType["VatTaxable"] = 1] = "VatTaxable";
    /** ԱԱՀ-ով չհարկվող — VAT exempt */
    TaxType[TaxType["VatExempt"] = 2] = "VatExempt";
    /** շրջ.հարկ — turnover tax */
    TaxType[TaxType["TurnoverTax"] = 3] = "TurnoverTax";
})(TaxType || (TaxType = {}));
export function choiceSelectionMode(group) {
    return group?.selectionMode === 'combine' ? 'combine' : 'separate';
}
export function choiceMinSelect(group) {
    const n = group?.minSelect;
    return n != null && n >= 1 ? n : 1;
}
export function choiceMaxSelect(group) {
    const n = group?.maxSelect;
    return n != null && n > 0 ? n : Number.POSITIVE_INFINITY;
}
export function isChoiceSelectionComplete(groups, selectedCount) {
    if (!groups?.length)
        return true;
    const group = groups[0];
    return selectedCount >= choiceMinSelect(group) && selectedCount <= choiceMaxSelect(group);
}
/** Dram change for one modifier on a product. Percent is rounded to the nearest dram. */
export function modifierDramDelta(productPrice, option) {
    if (option.deltaPercent != null && Number.isFinite(option.deltaPercent)) {
        return Math.round((productPrice * option.deltaPercent) / 100);
    }
    return option.priceDelta ?? 0;
}
//# sourceMappingURL=menu.js.map